import dayjs from 'dayjs';

/**
 * 下拉选择过滤函数
 */
export function filterOption (input, option){
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};


export function getCurrentUser(){
    var userInfo = localStorage.getItem('userInfo');
    var currentUser = {
        gameId: 0
    };

    if(userInfo != null && userInfo != undefined && userInfo !=""){
        currentUser = JSON.parse(localStorage.getItem('userInfo'));
    }
    return currentUser;
}

export function getEgDate(){

    const currentUser = getCurrentUser();

    return 'e.g: '+ dayjs().format(currentUser.dateFormat);
}

export function userDateFormat(date){

    if(date == null || date == undefined){
        return "";
    }
    const currentUser = getCurrentUser();

    return dayjs(date).format(currentUser.dateFormat);
}